
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1883|4612|5901|8868|9305)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
